module.exports = __webpack_public_path__ + "img/17869_S.a6966688.png";